angular.module("app").directive("colorShadesFrequencyAuto", () => {
  let link = (scope) => {
    scope.setWidth= percent => {
      let per = percent.replace('%', '');
      let percentage = parseFloat(per) + 0.4;
      return percentage +'%'
    }
  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbColorShadesFrequencyAuto/dbColorShadesFrequencyAutoView.html",
    link: link,
    scope: {
      data: "="
    }
  };
});
